'use strict';

var SoftLimitService = function SoftLimitService($rootScope, $q, App) {
  var DEFAULT_SOFT_LIMIT = App.softLimit || 20000;
  function confirm(count, dataSourceSoftLimit, value) {
    var applicableSoftLimit = dataSourceSoftLimit || DEFAULT_SOFT_LIMIT;
    if (count < applicableSoftLimit) {
      return $q.when(value);
    }
    var defer = $q.defer();
    $rootScope.$broadcast('confirmation:show', 'soft-limit', applicableSoftLimit);
    var unbind = $rootScope.$on('confirmation:soft-limit:result', function (e, res) {
      if (res) {
        defer.resolve(value);
      } else {
        defer.reject();
      }
      unbind();
    });
    return defer.promise;
  }
  return {
    confirm: confirm
  };
};
SoftLimitService.$inject = ['$rootScope', '$q', 'App'];
module.exports = SoftLimitService;